jQuery(function( $ ) {
	'use strict'

	// An object that handles the display of a warning modal

    window.InfoModalManager = {

        defaultTitle        : 'Attention',
        defaultMessage 	    : 'Information should be presented here.',
        defaultButtonText 	: 'OK',

        modal               : $( '#modal-info' ),
		copyButton  		: $( '#modal-info .btn-copy' ),
		confirmationButton  : $( '#modal-info .btn-confirm' ),

        show : function( args ) {
            this.title      = args.title        ? args.title        : this.defaultTitle;
            this.message    = args.message      ? args.message      : this.defaultMessage;
            this.buttonText = args.buttonText   ? args.buttonText   : this.defaultButtonText;

            this.modal.find( '.modal-title' ).text( args.title );
            this.modal.find( '.message' ).html( args.message );
            this.confirmationButton.text( args.buttonText );

			this.copyButton.off( 'click' );
			this.copyButton.on( 'click', window.InfoModalManager.copy );

			this.confirmationButton.off( 'click' );
			this.confirmationButton.on( 'click', window.InfoModalManager.submit );

			this.modal.modal();
		},

		submit : function() {
			window.InfoModalManager.modal.modal( 'hide' );
		},

		copy : function() {
			window.InfoModalManager.modal.find( '.message' )[0].select();
			document.execCommand( 'copy' );
		},

    };

});
